module.exports = __webpack_public_path__ + "img/upload-sample-right.f98eb94d.png";